module.exports = __webpack_public_path__ + "static/img/4.ca1cd09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/4.png
// module id = w7e+
// module chunks = 12